// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_aq-3";
export var contentContainer = "_aq-0";
export var editorContainer = "_aq-1";
export var quillInputForm = "_aq-2";
export var zoneDivider = "_aq-4";